import React, { useState, useEffect } from 'react';
import { Menu, X, Phone, Mail } from 'lucide-react';
import { companyInfo } from '../data/mock';
import { Button } from './ui/button';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { href: '#inicio', label: 'Inicio' },
    { href: '#nosotros', label: 'Acerca de Nosotros' },
    { href: '#servicios', label: 'Servicios' },
    { href: '#contacto', label: 'Contáctenos' }
  ];

  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-slate-900/95 backdrop-blur-md shadow-lg'
          : 'bg-transparent'
      }`}
    >
      {/* Top bar */}
      <div className="hidden md:block bg-slate-800/80 border-b border-slate-700/50">
        <div className="container mx-auto px-6 py-2">
          <div className="flex justify-end items-center gap-6 text-sm">
            <a
              href={`mailto:${companyInfo.email}`}
              className="flex items-center gap-2 text-slate-300 hover:text-orange-400 transition-colors"
            >
              <Mail size={14} />
              {companyInfo.email}
            </a>
            <a
              href={`tel:${companyInfo.phone}`}
              className="flex items-center gap-2 text-slate-300 hover:text-orange-400 transition-colors"
            >
              <Phone size={14} />
              {companyInfo.phone}
            </a>
          </div>
        </div>
      </div>

      {/* Main navigation */}
      <nav className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <a href="#inicio" onClick={(e) => scrollToSection(e, '#inicio')} className="flex-shrink-0">
            <img
              src={companyInfo.logo}
              alt={companyInfo.name}
              className="h-12 md:h-14 w-auto object-contain"
            />
          </a>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => scrollToSection(e, link.href)}
                className="text-slate-200 hover:text-orange-400 transition-colors font-medium relative group"
              >
                {link.label}
                <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-orange-400 transition-all duration-300 group-hover:w-full" />
              </a>
            ))}
            <Button
              onClick={(e) => scrollToSection(e, '#contacto')}
              className="bg-orange-500 hover:bg-orange-600 text-white px-6 transition-all duration-300 hover:scale-105"
            >
              Solicitar Cotización
            </Button>
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2 text-slate-200 hover:text-orange-400 transition-colors"
          >
            {isMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        <div
          className={`md:hidden overflow-hidden transition-all duration-300 ${
            isMenuOpen ? 'max-h-96 opacity-100 mt-4' : 'max-h-0 opacity-0'
          }`}
        >
          <div className="bg-slate-800/95 backdrop-blur-md rounded-xl p-4 space-y-2">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => scrollToSection(e, link.href)}
                className="block py-3 px-4 text-slate-200 hover:text-orange-400 hover:bg-slate-700/50 rounded-lg transition-all"
              >
                {link.label}
              </a>
            ))}
            <div className="pt-2 px-4">
              <a
                href={`tel:${companyInfo.phone}`}
                className="flex items-center gap-2 text-slate-300 hover:text-orange-400 py-2 transition-colors"
              >
                <Phone size={16} />
                {companyInfo.phone}
              </a>
              <a
                href={`mailto:${companyInfo.email}`}
                className="flex items-center gap-2 text-slate-300 hover:text-orange-400 py-2 transition-colors"
              >
                <Mail size={16} />
                {companyInfo.email}
              </a>
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;
